import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
var render = function render() {
  var _vm$wine$sku, _vm$tastingPhotos$req, _vm$tastingPhotos$req2, _vm$wine$externalIds, _vm$wine$region, _vm$supplierPrice, _vm$wine$externalIds2, _vm$wine$region2, _vm$wine$region3, _vm$wine$appellation;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [!_vm.wine.id_wine && !this.$route.query.edit || _vm.wineIsDeleted ? _c("div", [_c("h1", [_vm._v("Oups !")]), _c("p", [_vm._v(" Something went wrong ! Do not hesitate to go back to the search page by following this link : ")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.$router.replace({
          name: _vm.routeName
        });
      }
    }
  }, [_vm._v(" Go back to list ")])], 1) : _vm._e(), _vm.loaded && !_vm.wineIsDeleted ? [!this.$route.query.edit ? _c("div", [_c("div", {
    staticClass: "container-centered small"
  }, [_c("div", {
    attrs: {
      id: "content-top"
    }
  }, [_c("div", {
    attrs: {
      id: "wine-details-left"
    }
  }, [_c("img", {
    staticClass: "d-none",
    attrs: {
      src: _vm.wine.image,
      alt: ""
    },
    on: {
      error: function error($event) {
        _vm.isMainImageBroken = true;
      }
    }
  }), !_vm.isMainImageBroken && _vm.wine.image && _vm.wine.image.length > 0 ? _c("ProductZoomer", {
    attrs: {
      id: "img-wine",
      "base-images": _vm.wineImage,
      "base-zoomer-options": _vm.zoomerOptions
    }
  }) : _vm._e(), _vm._m(0), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    attrs: {
      id: "wine-details-links"
    }
  }, [_c("div", [_c("router-link", {
    attrs: {
      to: {
        name: "adminStockList",
        query: {
          id_wine: _vm.wine.id_wine
        }
      }
    }
  }, [_vm._v(" See stocks ")])], 1), _vm.canManageStock ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: "",
      to: {
        name: "adminStockDetails",
        query: {
          id_wine: _vm.wine.id_wine
        }
      }
    }
  }, [_vm._v(" + New stock ")])], 1) : _vm._e()]) : _vm._e()], 1), _c("div", {
    attrs: {
      id: "wine-details-right"
    }
  }, [_c("div", {
    attrs: {
      id: "wine-informations-text"
    }
  }, [_c("div", {
    attrs: {
      id: "wine-informations-left"
    }
  }, [_vm.$whitelabel.isMultipleWineries ? _c("div", {
    attrs: {
      id: "wine-producer"
    }
  }, [_c("router-link", {
    staticClass: "router-link",
    attrs: {
      to: _vm.goToProducerDetails(_vm.wine.producer.id)
    }
  }, [_vm._v(" " + _vm._s(_vm.wine.producer.name) + " ")])], 1) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-naming"
    }
  }, [_c("wine-naming", {
    key: "wine-naming-".concat(_vm.wine.id_wine),
    attrs: {
      wineNamingData: _vm.wine.naming_data,
      isPrefixWinery: false,
      isSuffixBottling: false,
      isSuffixType: false,
      boolRender: _vm.wineNamingBoolRender
    }
  })], 1), _c("div", {
    attrs: {
      id: "wine-description"
    }
  }, [_vm._v(" " + _vm._s(_vm.wine.details.description) + " ")]), _c("div", {
    attrs: {
      id: "wine-bottling"
    }
  }, [_c("div", [_vm.wine.bottling > 0 ? [_vm._v(" " + _vm._s(_vm.bottlings.find(function (x) {
    return x.value == _vm.wine.bottling;
  }).text) + " - ")] : _vm._e(), _vm._v(" " + _vm._s(_vm.getWineType(_vm.wine.naming_data.wine_type)) + " ")], 2)])]), _c("div", {
    attrs: {
      id: "wine-informations-right"
    }
  }, [_c("div", {
    attrs: {
      id: "wine-informations-right-data"
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.wine.region.name))]), _vm.wine.details.composition ? _c("div", [_vm._v(_vm._s(_vm.wine.details.composition))]) : _vm._e(), _vm.wine.alcohol_level_category ? _c("div", [_vm._v(" " + _vm._s(_vm.isAdminNotConsultant(_vm.loggedUserData) ? _vm.alcoholLevelCategories.find(function (x) {
    return x.id == _vm.wine.alcohol_level_category;
  }).text : _vm.alcoholLevelCategories.find(function (x) {
    return x.id == _vm.wine.alcohol_level_category;
  }).textForUsers) + " ")]) : _vm._e()]), _c("div", {
    attrs: {
      id: "more-info-link"
    }
  }, [_c("span", {
    on: {
      click: function click($event) {
        return _vm.scrollTo("#content-details");
      }
    }
  }, [_vm._v("more details")])])])]), _c("div", {
    attrs: {
      id: "wine-utils"
    }
  }, [_vm.cellarWine ? _c("div", {
    staticClass: "cellar-wine-qty",
    class: [_vm.cellarWine.quantity < 24 ? "low-stock" : ""]
  }, [_c("span", [_vm._v(_vm._s(_vm.cellarWine.quantity))]), _vm._v(" bottle" + _vm._s(_vm.cellarWine.quantity > 1 ? "s" : "") + " in inventory ")]) : _vm._e(), _c("TargetSelectors", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      thirdPartyContainerClass: "--flex-column --flex-end --last-65p",
      pricePostingContainerClass: "--flex-column --flex-end --last-65p"
    },
    on: {
      changeThirdPartyUserSelected: _vm.changeThirdPartyUserSelected,
      changePricePostingSelected: _vm.changePricePostingSelected
    }
  }), _c("div", {
    attrs: {
      id: "wine-line-btn-container"
    }
  }, [_vm.$whitelabel.tenantType == _vm.tenantType.OWNER ? _c("div", {
    attrs: {
      id: "wine-stock-review"
    }
  }, [_c("div", [!_vm.isIndividual(_vm.loggedUserData) ? _c("div", {
    attrs: {
      id: "wine-utils-sku"
    }
  }, [_vm._v(" " + _vm._s((_vm$wine$sku = _vm.wine.sku) !== null && _vm$wine$sku !== void 0 ? _vm$wine$sku : _vm.wine.accountancy_code) + " ")]) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-stock"
    }
  }, [!_vm.wine.stock_quantity || _vm.wine.stock_quantity < _vm.casingIdSelected.match(/\d+/)[0] ? _c("div", {
    staticClass: "wine-stock-availability --unavailable"
  }, [_c("span", [_vm._v("sold out")])]) : _c("div", {
    class: ["wine-stock-availability", _vm.wineRaritiesValues.find(function (x) {
      return x.id == _vm.wine.rarity;
    }).stockClass]
  }, [_vm.isAdminNotConsultant(_vm.loggedUserData) || _vm.isConsultantNotHolding(_vm.loggedUserData) ? _c("span", {
    staticClass: "wine-stock-quantity"
  }, [_vm._v(" " + _vm._s(_vm.wine.stock_quantity + "b ") + " ")]) : !_vm.isIndividual(_vm.loggedUserData) ? _c("span", {
    staticClass: "wine-stock-quantity"
  }, [_vm._v(" " + _vm._s(_vm.wine.stock_quantity >= 12 ? "12b+ " : _vm.wine.stock_quantity + "b ") + " ")]) : _vm._e(), _c("span", [_vm._v(" " + _vm._s(_vm.wineRaritiesValues.find(function (x) {
    return x.id == _vm.wine.rarity;
  }).stockText + (_vm.wine.stock_type.toLowerCase() == "consignment" && (_vm.isAdminNotConsultant(_vm.loggedUserData) || _vm.isConsultantOrHolding(_vm.loggedUserData)) ? " dw" : "")) + " ")])])]), _c("div", {
    attrs: {
      id: "wine-review"
    }
  }, [_vm.$whitelabel.isRatingEnabled ? _c("div", {
    attrs: {
      id: "wine-rating-container"
    }
  }, [_c("rating", {
    staticClass: "rating",
    attrs: {
      idWine: _vm.wine.id_wine
    }
  })], 1) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-add-favorites"
    },
    on: {
      click: function click($event) {
        return _vm.toggleFavorite(_vm.wine);
      }
    }
  }, [_vm.wine.favorite ? _c("i", {
    staticClass: "favorite fas fa-heart",
    attrs: {
      title: "Remove from your favorites"
    }
  }) : _c("i", {
    staticClass: "fas fa-heart",
    attrs: {
      title: "Add to your favorites"
    }
  })])])])]) : _c("div", {
    staticClass: "--pabus",
    attrs: {
      id: "wine-stock-review"
    }
  }, [_c("div", [_c("div", {
    attrs: {
      id: "wine-review"
    }
  }, [_c("div", {
    attrs: {
      id: "wine-add-favorites"
    },
    on: {
      click: function click($event) {
        return _vm.toggleFavorite(_vm.wine);
      }
    }
  }, [_vm.wine.favorite ? _c("i", {
    staticClass: "favorite fas fa-heart",
    attrs: {
      title: "Remove from your favorites"
    }
  }) : _c("i", {
    staticClass: "fas fa-heart",
    attrs: {
      title: "Add to your favorites"
    }
  })]), _c("div", {
    attrs: {
      id: "wine-stock"
    }
  }, [!_vm.wine.stock_quantity || _vm.wine.stock_quantity < _vm.casingIdSelected.match(/\d+/)[0] ? _c("div", {
    staticClass: "wine-stock-availability --unavailable"
  }, [_c("span", [_vm._v("sold out")])]) : _c("div", {
    class: ["wine-stock-availability", _vm.wineRaritiesValues.find(function (x) {
      return x.id == _vm.wine.rarity;
    }).stockClass]
  }, [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("span", {
    staticClass: "wine-stock-quantity"
  }, [_vm._v(" " + _vm._s(_vm.wine.stock_quantity + " ") + " ")]) : _vm._e(), _c("span", [_vm._v(" " + _vm._s(_vm.wineRaritiesValues.find(function (x) {
    return x.id == _vm.wine.rarity;
  }).stockText) + " ")])])])])])]), _c("div", {
    attrs: {
      id: "wine-price-deal-container"
    }
  }, [_vm.wine.hasSpecialDeals ? _c("div", {
    attrs: {
      id: "wine-special-deal"
    }
  }, [_vm._v(" " + _vm._s("With special deal") + " ")]) : _vm._e(), _c("div", {
    class: [_vm.wine.hasSpecialDeals ? "with-special-deal" : ""],
    attrs: {
      id: "wine-btns-container"
    }
  }, [!!_vm.wineInfoLimited ? _c("div", {
    attrs: {
      id: "wine-btns-limited"
    }
  }, [_vm._v(" ** " + _vm._s(_vm.wineInfoLimited) + " ** ")]) : _vm._e(), !!_vm.wine.buy_limit && (_vm.isUserBuyerGroup(_vm.loggedUserData) && !_vm.hasBypassBuyLimit() || _vm.isAdminNotConsultant(_vm.loggedUserData) && !!_vm.getThirdPartyUserSelected() && !_vm.thirdPartyUserHasBypassBuyLimit) && _vm.wine.stock_reservation_type != _vm.stockReservationTypes.SPECIFIC_CUSTOMER.id && _vm.wine.stock_reservation_type != _vm.stockReservationTypes.SPECIFIC_CONSULTANT.id ? _c("div", {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(" " + _vm._s(_vm.isUserBuyerGroup(_vm.loggedUserData) ? "My" : "Client") + " buy limit per year : " + _vm._s((_vm.wine.bottlesBoughtThisYearCount > _vm.wine.buy_limit ? _vm.wine.buy_limit : _vm.wine.bottlesBoughtThisYearCount) + "/" + _vm.wine.buy_limit + " b.") + " ")]) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-btns"
    }
  }, [_c("div", {
    attrs: {
      id: "wine-btns-line"
    }
  }, [_vm.isBuyer() ? [_vm.isLoadingWine ? _c("div", {
    staticClass: "wine-details-price mb-3 mt-3"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "20",
      width: "1"
    }
  })], 1) : _c("div", {
    staticClass: "wine-details-price-and-discount"
  }, [_c("div", {
    staticClass: "wine-details-price"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.wine.customerPriceIncludeDefaultShippingCurrency - _vm.discountAmount, _vm.wine.currency, _vm.casingIdSelected.match(/\d+/)[0])) + " ")]), _vm.casingIdSelected.match(/\d+/)[0] > 1 ? _c("div", {
    staticClass: "wine-details-unit-price"
  }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.wine.customerPriceIncludeDefaultShippingCurrency - _vm.discountAmount, _vm.wine.currency)) + " / bottle ")]) : _vm._e()]), _c("WineDiscountTooltip", {
    attrs: {
      wine: _vm.wine,
      currency: _vm.currency,
      casingId: _vm.casingIdSelected
    }
  })], 1), _vm.isLoadingWine ? _c("div", {
    staticClass: "wine-details-sold-out"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "20",
      width: "1"
    }
  })], 1) : _vm.isSoldOutDisplayed ? _c("div", {
    staticClass: "wine-details-sold-out"
  }, [_c("div", [_vm._v("Sold out")]), _vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("router-link", {
    attrs: {
      to: _vm.routerLinkConciergerie
    }
  }, [_c("span", [_vm._v("conciergerie")])]) : _vm._e()], 1) : !_vm.canPurchaseWine ? _c("div", {
    staticClass: "wine-details-sold-out"
  }, [_c("WineRangeAccessibility", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      wine: _vm.wine,
      currency: _vm.currency
    }
  })], 1) : _c("div", {
    staticClass: "wine-details-add-basket"
  }, [_c("div", {
    staticClass: "wine-details-add-qty"
  }, [_c(VTextField, {
    staticClass: "--addBasketWinePage text-right",
    attrs: {
      type: "number",
      min: 1,
      value: 1,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.refreshUnitPriceAccordingToQuantity();
      }
    },
    model: {
      value: _vm.addQuantity,
      callback: function callback($$v) {
        _vm.addQuantity = $$v;
      },
      expression: "addQuantity"
    }
  })], 1), _c("div", [_vm._v("x")]), _c("div", {
    staticClass: "wine-card-add-conditionment"
  }, [_c(VSelect, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.casingsAvailable,
      "item-value": "casingId",
      "item-text": "textCard",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.refreshUnitPriceAccordingToQuantity();
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          class: !item.id ? "text-card-warning" : ""
        }, [_vm._v(" " + _vm._s(item.textCard) + " ")])];
      }
    }], null, false, 1319746283),
    model: {
      value: _vm.casingIdSelected,
      callback: function callback($$v) {
        _vm.casingIdSelected = $$v;
      },
      expression: "casingIdSelected"
    }
  })], 1), _c("wine-add-cart-btn", {
    attrs: {
      loading: _vm.isAddingToCart.includes(_vm.wine.id_wine),
      click: function click() {
        return _vm.addItemToCart(_vm.wine, _vm.casingIdSelected);
      },
      isStockIncompatible: _vm.isStockIncompatible
    }
  })], 1)] : [_c("div", {
    staticClass: "wine-details-price wine-details-price--full"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.wine.customerPriceIncludeDefaultShippingCurrency - _vm.discountAmount, _vm.wine.currency, _vm.casingIdSelected.match(/\d+/)[0])) + " ")]), _vm.casingIdSelected !== "OC1" && _vm.casingIdSelected !== "OWC1" ? _c("div", {
    staticClass: "wine-details-unit-price"
  }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.wine.customerPriceIncludeDefaultShippingCurrency - _vm.discountAmount, _vm.wine.currency)) + " / bottle ")]) : _vm._e()])]], 2)]), _c("div", {
    staticClass: "wine-details-tax-info"
  }, [_vm._v(" incl. appl. sales taxes & default shipping ")])])])]), _vm.canManage || _vm.canEditDiscounts || _vm.canManageSupplierPrices || ((_vm$tastingPhotos$req = _vm.tastingPhotos.required.items) === null || _vm$tastingPhotos$req === void 0 ? void 0 : _vm$tastingPhotos$req.length) > 0 ? _c("div", {
    staticClass: "btns-edit-prices"
  }, [_vm.canManage && _vm.canEditCogs ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openScheduledCogs();
      }
    }
  }, [_c("i", {
    staticClass: "far fa-calendar-alt mr-1"
  }), _vm._v(" Scheduled cogs ")]) : _vm._e(), _vm.canManageSupplierPrices ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openSupplierPrices();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-search-dollar mr-1"
  }), _vm._v(" Supplier prices ")]) : _vm._e(), _vm.canEditDiscounts ? [_vm.discountsHasAccessToNewInterface ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openDiscounts();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-pen mr-1"
  }), _vm._v(" Edit discounts ")]) : _c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openOldDiscounts();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-pen mr-1"
  }), _vm._v(" Edit discounts ")])] : _vm._e(), ((_vm$tastingPhotos$req2 = _vm.tastingPhotos.required.items) === null || _vm$tastingPhotos$req2 === void 0 ? void 0 : _vm$tastingPhotos$req2.length) > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      to: _vm.routeToTastingPhotos()
    }
  }, [_c("i", {
    staticClass: "fa fa-camera mr-1"
  }), _vm._v(" Tasting photos ")]) : _vm._e()], 2) : _vm._e()], 1), !_vm.mapFailedLoading ? _c("div", [_c("div", {
    attrs: {
      id: "container-iframe"
    }
  }, [_c("Map", {
    attrs: {
      types: ["cadastre"],
      cadastreName: _vm.cadastreName,
      address: _vm.producerAddress,
      guid: _vm.wine.guid_mapbox ? _vm.wine.guid_mapbox : _vm.wine.producer.guidMapbox
    },
    on: {
      mapFailedLoading: function mapFailedLoading($event) {
        _vm.mapFailedLoading = true;
      }
    }
  })], 1)]) : _vm._e(), _c("div", {
    attrs: {
      id: "content-details"
    }
  }, [_c("div", {
    attrs: {
      id: "main-details-wrapper"
    }
  }, [_vm.canManage ? _c("div", [_c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(1), _c("div", {
    staticClass: "text-small"
  }, [_vm._v(" " + _vm._s(_vm.wine.is_active ? "Activated" : "Unactivated") + " ")])]), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.canEditCogs ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(2), _c("div", {
    staticClass: "text-small"
  }, [_vm.currency == "EUR" ? _c("span", [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.wine.cogs_euro_ex_vat)) + " " + _vm._s("€") + " ")]) : _c("span", [_vm._v(" " + _vm._s(_vm.formatPriceCartCurrency(_vm.wine.cogs_euro_ex_vat)) + " (" + _vm._s(_vm.formatPrice(_vm.wine.cogs_euro_ex_vat)) + " " + _vm._s("€") + ") ")])]), _vm.canEditCogs || _vm.canManagePricePosting ? _c("div", [_vm.canEditCogs ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.openWineCogsHistoryModal
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-history mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cogs history ")], 1) : _vm._e(), _vm.canManagePricePosting ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.openPricesPostingHistoryModal
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-history mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Price posted history ")], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) && _vm.wine.buy_limit ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(3), _c("div", {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.wine.buy_limit))])]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(4), _c("div", {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.wine.hs_code || "Undefined"))])]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(5), _c("div", {
    staticClass: "text-small"
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.wine.id_range ? _vm.ranges.find(function (x) {
    return x.id_range == _vm.wine.id_range;
  }).label : "Undefined") + " ")])])]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(6), _c("div", {
    staticClass: "text-small"
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.wine.rangeAccessibility ? "".concat(_vm.listWineRangeAccessibility.find(function (x) {
    return x.id == _vm.wine.rangeAccessibility;
  }).textForProductFilters) : "Undefined") + " ")])])]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(7), _c("div", {
    staticClass: "text-small"
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.wine.has_limited_quantity ? "Has limited quantity indication" : "Has NOT limited quantity indication") + " ")])])]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(8), _c("div", {
    staticClass: "text-small"
  }, [_c("span", [_vm._v(" " + _vm._s(_vm.wine.isTastingPhotoRequired ? "Has tasting photo required" : "Has NOT tasting photo required") + " ")])])]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) && _vm.wine.accountancy_code ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(9), _c("div", {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.wine.accountancy_code))]), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "flex items-start"
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      readonly: ""
    },
    model: {
      value: _vm.wine.bypass_appellation_doublon,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "bypass_appellation_doublon", $$v);
      },
      expression: "wine.bypass_appellation_doublon"
    }
  }), _vm._m(10)], 1) : _vm._e()]) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) && _vm.wine.accountancy_code ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(11), _c("div", {
    staticClass: "text-small"
  }, [_vm._v(_vm._s(_vm.wine.id_ttb))])]) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) && ((_vm$wine$externalIds = _vm.wine.externalIds) === null || _vm$wine$externalIds === void 0 ? void 0 : _vm$wine$externalIds.length) > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(12), _vm._l(_vm.wine.externalIds, function (externalId) {
    var _externalId$externalP;
    return _c("div", {
      key: "external-id-" + externalId.id,
      staticClass: "text-small"
    }, [_vm._v(" " + _vm._s(externalId.externalPlatformName) + " : " + _vm._s(externalId.externalPlatformId) + " "), ((_externalId$externalP = externalId.externalPlatformLink) === null || _externalId$externalP === void 0 ? void 0 : _externalId$externalP.length) > 0 ? _c("a", {
      staticClass: "router-link ml-2 text-smaller text-italic",
      attrs: {
        href: externalId.externalPlatformLink,
        target: "_blank"
      }
    }, [_vm._v(" (See on " + _vm._s(externalId.externalPlatformName) + ") ")]) : _vm._e()]);
  })], 2) : _vm._e()]) : _vm._e(), _c("div", [_vm.wine.type ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(13), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.getWineType(_vm.wine.type)))])]) : _vm._e(), _vm.wine.alcohol_level_category ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(14), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm.isAdminNotConsultant(_vm.loggedUserData) ? [_vm._v(" " + _vm._s(!!_vm.wine.alcohol_level ? "".concat(_vm.wine.alcohol_level, "% : ") : "") + " " + _vm._s(_vm.alcoholLevelCategories.find(function (x) {
    return x.id == _vm.wine.alcohol_level_category;
  }).text) + " ")] : [_vm._v(" " + _vm._s(_vm.alcoholLevelCategories.find(function (x) {
    return x.id == _vm.wine.alcohol_level_category;
  }).textForUsers) + " ")]], 2)]) : _vm._e(), _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(15), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(" " + _vm._s(_vm.bottlings.find(function (x) {
    return x.value == _vm.wine.bottling;
  }).text) + " ")])]), _vm.casings && _vm.casings.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(16), _c("div", {
    staticClass: "wine-details-bloc-text",
    domProps: {
      innerHTML: _vm._s(String.parseForVHtml(_vm.casings.map(function (x) {
        return _vm.casingWines.find(function (y) {
          return y.value == x;
        }).text;
      }).join("<br>")))
    }
  })]) : _vm._e(), _vm.wine.average_yield > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(17), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.average_yield))])]) : _vm._e(), _vm.wine.body_structure > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(18), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(" " + _vm._s(_vm.getBodyStructure(_vm.wine.body_structure)) + " ")])]) : _vm._e(), _vm.wine.details.soil && _vm.wine.details.soil.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(19), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.details.soil))])]) : _vm._e(), _vm.wine.details.composition && _vm.wine.details.composition.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(20), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.details.composition))])]) : _vm._e(), _vm.wine.details.aging_potential && _vm.wine.details.aging_potential.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(21), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.details.aging_potential))])]) : _vm._e(), _vm.wine.details.orientation && _vm.wine.details.orientation.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(22), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.details.orientation))])]) : _vm._e(), _vm.wine.details.temperature && _vm.wine.details.temperature.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(23), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(" " + _vm._s(_vm.wine.details.temperature.replaceAll("°C", "")) + "°C ")])]) : _vm._e(), _vm.wine.details.cooperage && _vm.wine.details.cooperage.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(24), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.details.cooperage))])]) : _vm._e(), _vm.wine.vineyard_size && _vm.wine.vineyard_size.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(25), _c("div", {
    staticClass: "wine-details-bloc-text"
  }, [_vm._v(_vm._s(_vm.wine.vineyard_size))])]) : _vm._e()])]), _c("div", {
    attrs: {
      id: "bigger-details-wrapper"
    }
  }, [_vm.wine.details.vignification && _vm.wine.details.vignification.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/barrel_grey.svg"),
      alt: ""
    }
  }), _vm._v(" " + _vm._s(_vm.wineIsSpirit ? "Distillation method" : "Vinification") + " ")]), _c("div", {
    staticClass: "wine-details-bloc-note",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.wine.details.vignification))
    }
  })]) : _vm._e(), _vm.wine.details.winemaker_note && _vm.wine.details.winemaker_note.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/account-part.svg"),
      alt: ""
    }
  }), _vm._v(" " + _vm._s(_vm.wineIsSpirit ? "Master blender" : "Winemaker note") + " ")]), _c("div", {
    staticClass: "wine-details-bloc-note",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.wine.details.winemaker_note))
    }
  })]) : _vm._e(), _vm.wine.details.service_advice && _vm.wine.details.service_advice.length > 0 ? _c("div", {
    staticClass: "wine-details-bloc"
  }, [_vm._m(26), _c("div", {
    staticClass: "wine-details-bloc-note",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.wine.details.service_advice))
    }
  })]) : _vm._e()])])])]), _vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", [_vm.cellarWine ? _c("comment", {
    attrs: {
      idCellarWine: _vm.cellarWine.id_cellar_wine,
      btnClassSupp: "--small"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.canManage ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.drawer = !_vm.drawer;
      }
    }
  }, [_vm._v(" Attached files ")]), _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.deleteWine();
      }
    }
  }, [_vm._v("Delete")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.callToClone();
      }
    }
  }, [_vm._v("Clone")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.callToUpdate();
      }
    }
  }, [_vm._v("Edit")])], 1) : _vm._e()])]) : _c("div", {
    attrs: {
      id: "edit-container"
    }
  }, [_c("div", {
    attrs: {
      id: "form-container"
    }
  }, [_c("div", {
    attrs: {
      id: "uploader"
    }
  }, [_c("p", {
    staticClass: "wine-uploader-properties"
  }, [_vm._v(" Portrait orientation. Height : 1100px. Background transparent. Format: PNG-24 ")]), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small mb-2",
    attrs: {
      rounded: true,
      href: _vm.wineImageProcessUrl,
      target: "_blank"
    }
  }, [_c("i", {
    staticClass: "fas fa-external-link-alt mr-1"
  }), _vm._v(" Improve your image with this app ")]), _c("Uploader", {
    attrs: {
      uploadMsg: "Click to upload or drop your product image here",
      max: 1,
      extensionsAllowed: ["png", "jpeg", "jpg", "webp"]
    },
    on: {
      change: _vm.handleImages
    }
  }), _vm.wine.image ? [_c("img", {
    staticClass: "img-wine",
    attrs: {
      src: _vm.wine.image,
      alt: ""
    }
  }), _c("div", [_c(VCheckbox, {
    attrs: {
      label: "Remove the wrong image",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.remove_main_image,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "remove_main_image", $$v);
      },
      expression: "wine.remove_main_image"
    }
  })], 1)] : _vm._e()], 2), _c("div", {
    attrs: {
      id: "data-container"
    }
  }, [_c("section", [_c("div", [_vm.isCloning ? [_c("div", {
    staticClass: "cloning-title-first-div"
  }, [_vm._v("Cloning product")]), _c("p", [_c("wine-naming", {
    key: "original-wine-naming-".concat(_vm.originalWine.id_wine),
    attrs: {
      wineNamingData: _vm.originalWine.naming_data,
      isPrefixWinery: true,
      isSuffixBottling: true
    }
  })], 1)] : _vm._e(), _c("p", [_c(VCheckbox, {
    attrs: {
      label: "Activated"
    },
    model: {
      value: _vm.wine.is_active,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "is_active", $$v);
      },
      expression: "wine.is_active"
    }
  })], 1)], 2), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Type")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listWineTypes,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "name",
      placeholder: "Red wine",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: _vm.changeType
    },
    model: {
      value: _vm.wine.type,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "type", $$v);
      },
      expression: "wine.type"
    }
  }), _vm.error.type.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.type) + " ")]) : _vm._e()], 1), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v(" " + _vm._s(!_vm.wineIsSpirit ? "Winery" : "Distillery") + " ")]), _c("div", {
    staticClass: "flex"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.displayListProducers,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      placeholder: "...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: _vm.changeProducer
    },
    model: {
      value: _vm.wine.producer,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "producer", $$v);
      },
      expression: "wine.producer"
    }
  }), _vm.producerList.canManage ? [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    attrs: {
      to: _vm.goToAddProducer(),
      target: "_blank"
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus",
    attrs: {
      size: "1.25rem"
    }
  })], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    attrs: {
      loading: _vm.producerList.isPending,
      disabled: _vm.producerList.isPending
    },
    on: {
      click: function click($event) {
        return _vm.refreshProducerList();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-sync",
    attrs: {
      size: "1.25rem"
    }
  })], 1)] : _vm._e()], 2), _vm.error.producer.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.producer) + " ")]) : _vm._e()]), _vm.wineIsSparkling ? _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Dosage")]), _vm.wine.region ? _c("div", {
    staticClass: "flex"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.dosages,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id_dosage",
      "item-text": "label",
      placeholder: "...",
      clearable: "",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.dosage,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "dosage", $$v);
      },
      expression: "wine.dosage"
    }
  }), _vm.canManageAppellations ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    on: {
      click: function click($event) {
        return _vm.openDosagePopin();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus",
    attrs: {
      size: "1.25rem"
    }
  })], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Region")]), _c("div", {
    staticClass: "flex"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.displayListRegions,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "displayName",
      "return-object": "",
      placeholder: "...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.changeRegion();
      }
    },
    model: {
      value: _vm.wine.region,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "region", $$v);
      },
      expression: "wine.region"
    }
  }), _vm.regionForm.canManageRegions ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    on: {
      click: function click($event) {
        return _vm.startAddRegion();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus",
    attrs: {
      size: "1.25rem"
    }
  })], 1) : _vm._e()], 1), _vm.error.region.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.region) + " ")]) : _vm._e()]), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v(" " + _vm._s(_vm.wineIsSpirit ? "Spirit region" : "Wine region") + " ")]), _c("div", {
    staticClass: "flex"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listSubRegions,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "return-object": "",
      placeholder: "...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.regionSub,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "regionSub", $$v);
      },
      expression: "wine.regionSub"
    }
  }), _vm.regionForm.canManageRegions ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    attrs: {
      disabled: !(((_vm$wine$region = _vm.wine.region) === null || _vm$wine$region === void 0 ? void 0 : _vm$wine$region.id) > 0)
    },
    on: {
      click: function click($event) {
        return _vm.startAddRegionSub();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus",
    attrs: {
      size: "1.25rem"
    }
  })], 1) : _vm._e()], 1), _vm.error.regionSub.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.regionSub) + " ")]) : _vm._e()]), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Appellation")]), _vm.wine.region ? _c("div", {
    staticClass: "flex"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.displayListAppellations,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "label",
      "return-object": "",
      placeholder: "...",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.changeAppellation();
      }
    },
    model: {
      value: _vm.wine.appellation,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "appellation", $$v);
      },
      expression: "wine.appellation"
    }
  }), _vm.canManageAppellations ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    on: {
      click: function click($event) {
        return _vm.openAppellationPopin();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus",
    attrs: {
      size: "1.25rem"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.error.appellation.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.appellation) + " ")]) : _vm._e()]), !_vm.wineIsSpirit ? _c("div", [_c("div", [_vm._v("Denomination")]), _vm.wine.appellation ? _c("div", {
    staticClass: "flex"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.wine.appellation.denominations,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "appellation",
      "return-object": "",
      placeholder: "...",
      clearable: "",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.changeDenomination();
      }
    },
    model: {
      value: _vm.wine.denomination,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "denomination", $$v);
      },
      expression: "wine.denomination"
    }
  }), _vm.canManageAppellations ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary px-3",
    on: {
      click: function click($event) {
        return _vm.openDenominationPopin();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus",
    attrs: {
      size: "1.25rem"
    }
  })], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _c("div", [_c("div", [_vm._v(_vm._s(!_vm.wineIsSpirit ? "Cuvee" : "Product name"))]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "...",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.cuvee,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "cuvee", $$v);
      },
      expression: "wine.cuvee"
    }
  }), _vm.error.cuvee.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.cuvee) + " ")]) : _vm._e()], 1), _c("div", [_c("div", [_vm._v("Vintage")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      type: "number",
      placeholder: "2000",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.year,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "year", $$v);
      },
      expression: "wine.year"
    }
  }), _vm.error.vintage.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.vintage) + " ")]) : _vm._e()], 1), _c("div", [_c("div", [_vm._v("Optional description (collection case)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "...",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.description,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "description", $$v);
      },
      expression: "wine.details.description"
    }
  })], 1)]), !((_vm$supplierPrice = _vm.supplierPrice) !== null && _vm$supplierPrice !== void 0 && _vm$supplierPrice.id) && (_vm.isAddWine || _vm.isCloning) ? _c("section", {
    staticClass: "wine-data-section"
  }, [!_vm.wine.supplierPrice.isCreateSupplierPriceLater ? _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Supplier")]), _c("SupplierSelectComponent", {
    ref: "supplierSelect",
    attrs: {
      classStyle: "v-text-field-no-label",
      suppliers: _vm.suppliers,
      selected: _vm.wine.supplierPrice.supplierId,
      required: false,
      disabled: false,
      label: ""
    },
    on: {
      changeSupplier: _vm.changeSupplier,
      fetchSuppliers: _vm.fetchSuppliersWhenItemsUpdated
    }
  }), _vm.error.supplierSelect.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.supplierSelect) + " ")]) : _vm._e()], 1) : _vm._e(), !_vm.wine.supplierPrice.isCreateSupplierPriceLater ? _c("div", [_c("div", {
    staticClass: "text-standalone-required bold"
  }, [_vm._v("Price / btl (€)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      min: "0.00",
      required: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.supplierPrice.price,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.supplierPrice, "price", $$v);
      },
      expression: "wine.supplierPrice.price"
    }
  }), _vm.error.supplierPrice.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.supplierPrice) + " ")]) : _vm._e()], 1) : _vm._e(), _c("div", {
    staticClass: "supplier-price-warning"
  }, [_c("p", {
    staticClass: "text-caption flex items-baseline mb-0"
  }, [_c(VCheckbox, {
    staticClass: "v-checkbox-with-label",
    attrs: {
      label: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.supplierPrice.isCreateSupplierPriceLater,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.supplierPrice, "isCreateSupplierPriceLater", $$v);
      },
      expression: "wine.supplierPrice.isCreateSupplierPriceLater"
    }
  }), _vm._v(" I have reviewed the "), _c("router-link", {
    attrs: {
      to: _vm.goToSupplierPricesList(),
      target: "_blank"
    }
  }, [_vm._v(" supplier prices list ")]), _vm._v(" and will associate an existing one after creating this wine. ")], 1)])]) : _vm._e(), _c("section", {
    staticClass: "wine-data-section"
  }, [_vm.isAddWine || _vm.canEditCogs ? _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("COGS (€)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      "hide-details": "auto",
      readonly: _vm.isEditWine && !_vm.canEditCogs
    },
    on: {
      input: _vm.updateRange
    },
    model: {
      value: _vm.wine.cogs_euro_ex_vat,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "cogs_euro_ex_vat", $$v);
      },
      expression: "wine.cogs_euro_ex_vat"
    }
  }), _vm.error.cogs_euro_ex_vat.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.cogs_euro_ex_vat) + " ")]) : _vm._e(), _vm.isEditWine && _vm.wine.cogs_euro_ex_vat != _vm.initialCogs ? [_c("div", {
    staticClass: "text-smaller mt-1"
  }, [_vm._v("Cogs update comment")]), _c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "2",
      placeholder: "Please explain why the COGS is updated",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.cogsUpdateComment,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "cogsUpdateComment", $$v);
      },
      expression: "wine.cogsUpdateComment"
    }
  })] : _vm._e(), _vm.isAddWine || _vm.isCloning ? [_c("div", {
    staticClass: "text-smaller mt-1"
  }, [_vm._v("Cogs explanation")]), _c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "2",
      placeholder: "Please explain how the COGS has been set",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.cogsUpdateComment,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "cogsUpdateComment", $$v);
      },
      expression: "wine.cogsUpdateComment"
    }
  })] : _vm._e(), _vm.isEditWine && _vm.canEditCogs ? _c("div", {
    staticClass: "flex justify-start mt-1"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openScheduledCogs();
      }
    }
  }, [_c("i", {
    staticClass: "far fa-calendar-alt mr-1"
  }), _vm._v(" Scheduled cogs ")])], 1) : _vm._e()], 2) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", [_c("div", [_vm._v("Range price")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.ranges,
      "item-value": "id_range",
      "item-text": "label",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      disabled: true,
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.id_range,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "id_range", $$v);
      },
      expression: "wine.id_range"
    }
  })], 1) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Range accessibility")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listWineRangeAccessibility,
      "item-value": "id",
      "item-text": "textForProductFilters",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.rangeAccessibility,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "rangeAccessibility", $$v);
      },
      expression: "wine.rangeAccessibility"
    }
  }), _vm.error.rangeAccessibility.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.rangeAccessibility) + " ")]) : _vm._e()], 1) : _vm._e(), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", [_c("div", [_vm._v("Tasting photo required")]), _c(VCheckbox, {
    staticClass: "v-checkbox-with-label",
    attrs: {
      label: "Has tasting photo required"
    },
    model: {
      value: _vm.wine.isTastingPhotoRequired,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "isTastingPhotoRequired", $$v);
      },
      expression: "wine.isTastingPhotoRequired"
    }
  })], 1) : _vm._e(), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Bottling")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.bottlings,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "value",
      "item-text": "text",
      placeholder: "750ML",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: _vm.updateRange
    },
    model: {
      value: _vm.wine.bottling,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "bottling", $$v);
      },
      expression: "wine.bottling"
    }
  }), _vm.error.bottling.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.bottling) + " ")]) : _vm._e()], 1), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Casings")]), _vm._m(27), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.casingWines,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "value",
      "item-text": "value",
      placeholder: "Select the casings",
      "hide-details": "auto",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.casings,
      callback: function callback($$v) {
        _vm.casings = $$v;
      },
      expression: "casings"
    }
  }), _c(VSelect, {
    attrs: {
      items: _vm.casings,
      label: "Default casing"
    },
    model: {
      value: _vm.defaultCasing,
      callback: function callback($$v) {
        _vm.defaultCasing = $$v;
      },
      expression: "defaultCasing"
    }
  }), _vm.error.casing.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.casing) + " ")]) : _vm._e()], 1), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("div", [_c("div", [_vm._v("Buy limit (bottles per year)")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      type: "number",
      placeholder: "None",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.buy_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "buy_limit", $$v);
      },
      expression: "wine.buy_limit"
    }
  }), _vm.error.buy_limit.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.error.buy_limit) + " ")]) : _vm._e(), _vm.error.buy_limit_casing.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.error.buy_limit_casing) + " ")]) : _vm._e()], 1) : _vm._e(), _c("div", [_c("div", [_vm._v("Rarity")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.wineRaritiesValues,
      "item-value": "id",
      "item-text": "name",
      "hide-details": "auto",
      "hide-no-data": "",
      "hide-selected": "",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.rarity,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "rarity", $$v);
      },
      expression: "wine.rarity"
    }
  }), _vm.error.rarity.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.error.rarity) + " ")]) : _vm._e()], 1), _c("div", [_c("div", [_vm._v("Quantity limited")]), _c(VCheckbox, {
    staticClass: "v-checkbox-with-label",
    attrs: {
      label: "Has limited quantity indication"
    },
    model: {
      value: _vm.wine.has_limited_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "has_limited_quantity", $$v);
      },
      expression: "wine.has_limited_quantity"
    }
  })], 1)]), !_vm.isUserBuyerGroup(_vm.loggedUserData) ? _c("section", {
    staticClass: "wine-data-section"
  }, [_c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("SKU base for stocks")]), _c("div", {
    staticClass: "accountancy_code-container"
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      disabled: !_vm.skuManual,
      placeholder: "WNRY-APCLAS-W20MAG",
      maxlength: "100",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.accountancy_code,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "accountancy_code", $$v);
      },
      expression: "wine.accountancy_code"
    }
  }), _c("div", {
    staticClass: "accountancy_code-icons"
  }, [!_vm.skuManual ? _c(VIcon, {
    attrs: {
      color: "black",
      title: "Manual edit the SKU"
    },
    on: {
      click: _vm.toggleSkuManual
    }
  }, [_vm._v(" fa-pen ")]) : _c(VIcon, {
    attrs: {
      color: "black",
      title: "Back to initial SKU"
    },
    on: {
      click: _vm.toggleSkuManual
    }
  }, [_vm._v(" fa-undo ")]), _c(VIcon, {
    attrs: {
      color: "black",
      title: "Use automatic SKU"
    },
    on: {
      click: _vm.getSkuGenerated
    }
  }, [_vm._v(" fa-grin-stars ")]), _vm.wine.id_wine ? _c(VIcon, {
    attrs: {
      color: "black",
      title: "Initial SKU"
    },
    on: {
      click: _vm.getSkuOriginal
    }
  }, [_vm._v(" fa-times ")]) : _vm._e()], 1)], 1), !_vm.wine.accountancy_code ? _c("p", {
    staticClass: "mb-0"
  }, [_vm._v('Automatic SKU "' + _vm._s(_vm.skuGenerated) + '"')]) : _vm.skuGenerated != _vm.wine.accountancy_code ? _c("p", {
    staticClass: "errorLabel --orange"
  }, [_c(VIcon, [_vm._v("fa-exclamation-triangle")]), _vm._v(' Automatic SKU "' + _vm._s(_vm.skuGenerated) + "\" doesn't match the product's SKU. You should use this SKU. "), _c(VIcon, [_vm._v("fa-exclamation-triangle")])], 1) : _vm._e(), _vm.wine.id_wine && !_vm.isCloning && (_vm.skuManual || _vm.wine.accountancy_code != _vm.skuOriginal) ? _c("p", {
    staticClass: "errorLabel"
  }, [_c(VIcon, [_vm._v("fa-exclamation-triangle")]), _vm._v(" If you change the SKU, all stocks associated will be automatically updated. You must notify the warehouses about this change. "), _c(VIcon, [_vm._v("fa-exclamation-triangle")])], 1) : _vm._e(), _vm.error.accountancy_code.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.accountancy_code) + " ")]) : _vm._e(), _c("div", {
    staticClass: "flex items-start mt-1"
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    model: {
      value: _vm.wine.bypass_appellation_doublon,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "bypass_appellation_doublon", $$v);
      },
      expression: "wine.bypass_appellation_doublon"
    }
  }), _vm._m(28)], 1)]), _c("div", [_c("div", [_vm._v("HS Code")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.StringHsCode,
      "hide-no-data": "",
      "item-value": "code",
      "item-text": "desc",
      placeholder: "2204",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.hs_code,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "hs_code", $$v);
      },
      expression: "wine.hs_code"
    }
  }), _vm.error.hs_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.error.hs_code) + " ")]) : _vm._e()], 1), _c("div", [_c("div", [_vm._v("TTB ID")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "22000000000000",
      maxlength: "100",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.id_ttb,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "id_ttb", $$v);
      },
      expression: "wine.id_ttb"
    }
  }), _vm.error.id_ttb.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.error.id_ttb) + " ")]) : _vm._e()], 1), _c("div", [_c("div", [_vm._v("External References")]), ((_vm$wine$externalIds2 = _vm.wine.externalIds) === null || _vm$wine$externalIds2 === void 0 ? void 0 : _vm$wine$externalIds2.length) > 0 ? _vm._l(_vm.wine.externalIds, function (externalId) {
    var _externalId$id;
    return _c("div", {
      key: "external-id-" + ((_externalId$id = externalId.id) !== null && _externalId$id !== void 0 ? _externalId$id : externalId.newGuid),
      staticClass: "text-small mb-3"
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        prefix: "Platform:",
        placeholder: "HAL",
        maxlength: "50",
        "hide-details": "auto"
      },
      model: {
        value: externalId.externalPlatformName,
        callback: function callback($$v) {
          _vm.$set(externalId, "externalPlatformName", $$v);
        },
        expression: "externalId.externalPlatformName"
      }
    }), _c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        prefix: "Ref:",
        placeholder: "",
        maxlength: "100",
        "hide-details": "auto"
      },
      model: {
        value: externalId.externalPlatformId,
        callback: function callback($$v) {
          _vm.$set(externalId, "externalPlatformId", $$v);
        },
        expression: "externalId.externalPlatformId"
      }
    }), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary mt-2",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.confirmRemoveExternalId(externalId);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-trash mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Remove ")], 1)], 1);
  }) : _c("div", {
    staticClass: "mt-1 mb-2 text-smaller text-italic"
  }, [_vm._v("No external reference")]), !_vm.newExternalIdIsConfiguring ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.newExternalIdIsConfiguring = true;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add external reference ")], 1)], 1) : _c("div", {
    staticClass: "text-smaller subform-bordered pl-4"
  }, [_c("div", {
    staticClass: "text-bold mt-1"
  }, [_vm._v("Add new external reference form")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      prefix: "Platform:",
      placeholder: "HAL",
      maxlength: "50",
      "hide-details": "auto"
    },
    model: {
      value: _vm.newExternalId.externalPlatformName,
      callback: function callback($$v) {
        _vm.$set(_vm.newExternalId, "externalPlatformName", $$v);
      },
      expression: "newExternalId.externalPlatformName"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      prefix: "Ref:",
      placeholder: "",
      maxlength: "100",
      "hide-details": "auto"
    },
    model: {
      value: _vm.newExternalId.externalPlatformId,
      callback: function callback($$v) {
        _vm.$set(_vm.newExternalId, "externalPlatformId", $$v);
      },
      expression: "newExternalId.externalPlatformId"
    }
  }), _c("div", {
    staticClass: "flex mt-2 gap-1"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.newExternalIdIsConfiguring = false;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.addNewExternalid
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add this reference to the product ")], 1)], 1)], 1)], 2)]) : _vm._e(), _c("section", {
    staticClass: "wine-data-section"
  }, [_c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v("Alcohol")]), _c(VCheckbox, {
    attrs: {
      label: "Precise the value",
      "hide-details": "auto"
    },
    on: {
      click: _vm.changeIsPrecisingAlcoholLevel
    },
    model: {
      value: _vm.isPrecisingAlcoholLevel,
      callback: function callback($$v) {
        _vm.isPrecisingAlcoholLevel = $$v;
      },
      expression: "isPrecisingAlcoholLevel"
    }
  }), _c(VTextField, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPrecisingAlcoholLevel,
      expression: "isPrecisingAlcoholLevel"
    }],
    staticClass: "v-text-field-no-label",
    attrs: {
      type: "number",
      min: "0",
      max: "100",
      placeholder: "Alcohol level (%)",
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterDecimalKey,
      input: _vm.changePrecisingAlcoholLevel
    },
    model: {
      value: _vm.wine.alcohol_level,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "alcohol_level", $$v);
      },
      expression: "wine.alcohol_level"
    }
  }), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.alcoholLevelCategories,
      disabled: _vm.isPrecisingAlcoholLevel,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "text",
      placeholder: "12 - 14% ALC.",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.alcohol_level_category,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "alcohol_level_category", $$v);
      },
      expression: "wine.alcohol_level_category"
    }
  }), _vm.error.alcohol_level_category.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.alcohol_level_category) + " ")]) : _vm._e()], 1), _c("div", [_c("div", {
    staticClass: "text-standalone-required"
  }, [_vm._v(" " + _vm._s(!_vm.wineIsSpirit ? "Composition" : "Formula") + " ")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: !_vm.wineIsSpirit ? "Chardonnay" : "Blend whisky",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.composition,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "composition", $$v);
      },
      expression: "wine.details.composition"
    }
  }), _vm.error.composition.length > 0 ? _c("p", {
    staticClass: "errorLabel --small"
  }, [_vm._v(" " + _vm._s(_vm.error.composition) + " ")]) : _vm._e()], 1), _c("div", [_c("div", [_vm._v("Body structure")]), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listBodyStructures,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "structure",
      "item-text": "text",
      placeholder: "Medium bodied",
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.wine.body_structure,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "body_structure", $$v);
      },
      expression: "wine.body_structure"
    }
  })], 1), !_vm.wineIsSpirit ? _c("div", [_c("div", [_vm._v("Vineyard size")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "2 ha",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.vineyard_size,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "vineyard_size", $$v);
      },
      expression: "wine.vineyard_size"
    }
  })], 1) : _vm._e(), !_vm.wineIsSpirit ? _c("div", [_c("div", [_vm._v("Average yield")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "50000",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.average_yield,
      callback: function callback($$v) {
        _vm.$set(_vm.wine, "average_yield", $$v);
      },
      expression: "wine.average_yield"
    }
  })], 1) : _vm._e(), _c("div", [_c("div", [_vm._v("Aging potential")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "2025",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.aging_potential,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "aging_potential", $$v);
      },
      expression: "wine.details.aging_potential"
    }
  })], 1), !_vm.wineIsSpirit ? _c("div", [_c("div", [_vm._v("Soil")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "Limestone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.soil,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "soil", $$v);
      },
      expression: "wine.details.soil"
    }
  })], 1) : _vm._e(), !_vm.wineIsSpirit ? _c("div", [_c("div", [_vm._v("Vine orientation")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "South",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.orientation,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "orientation", $$v);
      },
      expression: "wine.details.orientation"
    }
  })], 1) : _vm._e(), _c("div", [_c("div", [_vm._v("Temperature to keep")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "13",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.temperature,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "temperature", $$v);
      },
      expression: "wine.details.temperature"
    }
  })], 1), !_vm.wineIsSpirit ? _c("div", [_c("div", [_vm._v("Winemaking")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "Oak barrel",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.cooperage,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "cooperage", $$v);
      },
      expression: "wine.details.cooperage"
    }
  })], 1) : _vm._e()]), _c("section", [_c("div", [_c("div", [_vm._v("Service advice")]), _c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "2",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.service_advice,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "service_advice", $$v);
      },
      expression: "wine.details.service_advice"
    }
  })], 1), _c("div", [_c("div", [_vm._v(_vm._s(_vm.wineIsSpirit ? "Distillation method" : "Vinification"))]), _c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "3",
      placeholder: "In Oak barrels",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.vignification,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "vignification", $$v);
      },
      expression: "wine.details.vignification"
    }
  })], 1), _c("div", [_c("div", [_vm._v(_vm._s(_vm.wineIsSpirit ? "Master blender" : "Winemaker note"))]), _c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.wine.details.winemaker_note,
      callback: function callback($$v) {
        _vm.$set(_vm.wine.details, "winemaker_note", $$v);
      },
      expression: "wine.details.winemaker_note"
    }
  }), _vm.error.note.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.error.note) + " ")]) : _vm._e()], 1)]), _vm.isCloning ? _c("section", {
    staticClass: "clone-options-section"
  }, [_c("span", {
    staticClass: "clone-title"
  }, [_vm._v("Cloning transfer options")]), _c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      label: "Transfer conditional discounts (+ scheduled conditional discounts)"
    },
    model: {
      value: _vm.cloningOptions.transferConditionalDiscounts,
      callback: function callback($$v) {
        _vm.$set(_vm.cloningOptions, "transferConditionalDiscounts", $$v);
      },
      expression: "cloningOptions.transferConditionalDiscounts"
    }
  }), _c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      label: "Transfer commissions (+ scheduled commissions)"
    },
    model: {
      value: _vm.cloningOptions.transferCommissions,
      callback: function callback($$v) {
        _vm.$set(_vm.cloningOptions, "transferCommissions", $$v);
      },
      expression: "cloningOptions.transferCommissions"
    }
  }), _c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      label: "Transfer scheduled cogs"
    },
    model: {
      value: _vm.cloningOptions.transferCogs,
      callback: function callback($$v) {
        _vm.$set(_vm.cloningOptions, "transferCogs", $$v);
      },
      expression: "cloningOptions.transferCogs"
    }
  })], 1) : _vm._e()])]), _vm.canManage ? _c("div", [_vm.error.clone.length > 0 ? _c("p", {
    staticClass: "errorLabel text-center"
  }, [_vm._v(" " + _vm._s(_vm.error.clone) + " ")]) : _vm._e(), _vm.duplicateWines.length > 0 ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary ml-4",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openDuplicateList();
      }
    }
  }, [_vm._v(" See list of duplicates ")])], 1) : _vm._e(), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")]), !_vm.supplierPrice ? _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditWine ? "Save" : "Create") + " ")]) : _vm._e(), _vm.supplierPrice ? _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditWine ? "Save" : "Create for supplier price") + " ")]) : _vm._e()], 1)]) : _vm._e()])] : _vm._e(), _vm.canManage ? _c(VNavigationDrawer, {
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: "35%",
      temporary: "",
      stateless: _vm.isMakingDrawerStateless
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-section"
  }, [_c("div", {
    staticClass: "drawer-section-title mb-6"
  }, [_c("span", [_vm._v("Attached files")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    on: {
      click: function click($event) {
        return _vm.openTagsDialog();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-tag mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Manage tags ")], 1)], 1), _vm.isLoadingFiles ? _c(VSkeletonLoader, {
    attrs: {
      "max-height": "5rem",
      type: "image"
    }
  }) : [_c("div", {
    staticClass: "drawer-file-list"
  }, [!_vm.wineDocuments.length ? _c("p", {
    staticClass: "flex text-sm text-center"
  }, [_vm._v("No files yet")]) : _vm._e(), _vm._l(_vm.wineDocuments, function (file) {
    return _c("div", {
      key: file.id,
      staticClass: "global-file-chip"
    }, [_c("div", {
      staticClass: "tag"
    }, [file.tag ? _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: "",
        close: "",
        "close-icon": "mdi-close-thick"
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.removeTagFromDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("b", [_vm._v(_vm._s(file.tag.name))])], 1) : _c(VChip, {
      staticClass: "drawer-file-chip tag",
      attrs: {
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openAddTagToDocument(file.id);
        }
      }
    }, [_c(VIcon, {
      staticClass: "tag-icon",
      attrs: {
        left: "",
        small: ""
      }
    }, [_vm._v("mdi-tag")]), _c("p", {
      staticClass: "font-italic ma-0"
    }, [_vm._v("Add tag")]), _c(VIcon, {
      attrs: {
        right: ""
      }
    }, [_vm._v("mdi-plus-thick")])], 1)], 1), _c(VChip, {
      staticClass: "drawer-file-chip",
      attrs: {
        close: "",
        label: ""
      },
      on: {
        click: function click($event) {
          return _vm.openFileUrl(file.url);
        },
        "click:close": function clickClose($event) {
          return _vm.removeFile(file.id);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        left: ""
      }
    }, [_vm._v("mdi-cloud-download")]), _vm._v(" " + _vm._s(file.filename) + " ")], 1)], 1);
  })], 2)], _c("div", {
    staticClass: "withBeforeSeparator"
  }, [_c(VForm, {
    staticClass: "dfwa-form"
  }, [_c("div", {
    staticClass: "title text-left mb-2"
  }, [_vm._v("Upload new file")]), _vm.gettingDocumentTags.results.length ? _c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.gettingDocumentTags.results,
      clearable: "",
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "name",
      placeholder: "Tag",
      "hide-details": "auto",
      label: "Document tag"
    },
    model: {
      value: _vm.uploadAdditionalData.tagId,
      callback: function callback($$v) {
        _vm.$set(_vm.uploadAdditionalData, "tagId", $$v);
      },
      expression: "uploadAdditionalData.tagId"
    }
  }) : _vm._e(), _c("UploaderV2", {
    key: +_vm.drawer,
    attrs: {
      canClear: "",
      fileTypes: [".xlsx", ".xlsm", ".jpg", ".png", ".gif", ".pdf"],
      url: _vm.uploadUrl,
      additionalFormData: _vm.uploadAdditionalFormData,
      label: "Attach File(s) to wine"
    },
    on: {
      "click:upload": _vm.upload
    }
  })], 1)], 1)], 2)]), _c("ManageDocumentsTagsDialog", {
    ref: "ManageDocumentsTagsDialog",
    on: {
      tagListChanged: function tagListChanged($event) {
        return _vm.tagListChangedUpdate();
      }
    }
  }), _c("AddTagToDocumentDialog", {
    ref: "AddTagToDocumentDialog",
    on: {
      tagAddedToDocument: function tagAddedToDocument($event) {
        return _vm.tagListChangedUpdate();
      },
      openManageTagsDialog: function openManageTagsDialog($event) {
        return _vm.openTagsDialog();
      }
    }
  }), _c("confirm", {
    ref: "confirmDocumentDrawer"
  })], 1) : _vm._e(), _vm.canEditCogs ? _c("WineCogsHistoryModal", {
    ref: "WineCogsHistoryModal",
    attrs: {
      values: _vm.wine.cogsUpdates
    }
  }) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("WineStockListModal", {
    key: _vm.wineStockKey,
    ref: "WineStockListModal",
    attrs: {
      wine: _vm.currentWine,
      quantity: _vm.currentQuantity,
      casingId: _vm.casingIdSelected,
      add: _vm.addItemToCart,
      isBasket: true
    },
    on: {
      closed: _vm.closeWineStockListModal
    }
  }) : _vm._e(), _vm.isConditionalDiscountModalShown && _vm.canEditDiscounts ? _c("ConditionalDiscountModal", {
    ref: "ConditionalDiscountModal",
    attrs: {
      wineId: _vm.wine.id_wine
    },
    on: {
      closed: _vm.closeOldDiscounts
    }
  }) : _vm._e(), _vm.isConditionalDiscountV2ModalShown && _vm.canEditDiscounts ? _c("ConditionalDiscountV2Modal", {
    ref: "ConditionalDiscountV2Modal",
    attrs: {
      wineId: _vm.wine.id_wine
    },
    on: {
      closed: _vm.closeDiscounts
    }
  }) : _vm._e(), _vm.isWineSupplierPriceModalShown ? _c("WineSupplierPriceModal", {
    ref: "wineSupplierPriceModal",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      wineId: _vm.wine.id_wine
    },
    on: {
      closed: _vm.closeSupplierPrices
    }
  }) : _vm._e(), _vm.isDuplicateListDialogShown ? _c("WineDuplicateListDialog", {
    ref: "WineDuplicateListDialog",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      wines: _vm.duplicateWines
    },
    on: {
      closed: _vm.closeDuplicateList
    }
  }) : _vm._e(), _vm.appellationPopinShown ? _c("AppellationPopin", {
    ref: "appellationPopin",
    attrs: {
      regionIdSelected: (_vm$wine$region2 = _vm.wine.region) === null || _vm$wine$region2 === void 0 ? void 0 : _vm$wine$region2.id,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      closed: _vm.closeAppellationPopin
    }
  }) : _vm._e(), _vm.dosagePopinShown ? _c("DosagePopin", {
    ref: "dosagePopin",
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      closed: _vm.closeDosagePopin
    }
  }) : _vm._e(), _vm.denominationPopinShown ? _c("DenominationPopin", {
    ref: "denominationPopin",
    attrs: {
      regionIdSelected: (_vm$wine$region3 = _vm.wine.region) === null || _vm$wine$region3 === void 0 ? void 0 : _vm$wine$region3.id,
      parentAppellationIdSelected: (_vm$wine$appellation = _vm.wine.appellation) === null || _vm$wine$appellation === void 0 ? void 0 : _vm$wine$appellation.id_appellation,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      closed: _vm.closeDenominationPopin
    }
  }) : _vm._e(), _vm.isScheduledCogsModalShown && _vm.wine && _vm.canEditCogs ? _c("ScheduledWineCogsModal", {
    ref: "ScheduledCogsModal",
    attrs: {
      wineId: _vm.wine.id_wine,
      wineCogs: _vm.wine.cogs_euro_ex_vat,
      wineNamingData: _vm.wine.naming_data
    },
    on: {
      closed: _vm.closeScheduledCogs
    }
  }) : _vm._e(), this.$route.query.edit && _vm.regionForm.canManageRegions ? _c("RegionFormModal", {
    ref: "regionForm",
    attrs: {
      id: _vm.regionForm.editedId,
      initAddFormValues: _vm.regionForm.initAddFormValues,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      entityUpdated: function entityUpdated($event) {
        return _vm.refreshRegionList();
      },
      closed: function closed($event) {
        _vm.regionForm.editedId = null;
      }
    }
  }) : _vm._e(), _vm.wine && _vm.canManagePricePosting ? _c("PricePostedUsaEditModal", {
    ref: "pricePostingWineConditionalDiscountHistoryRef",
    attrs: {
      wine: _vm.wine
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "payment-informations-left"
    }
  }, [_c("div", [_c("i", {
    staticClass: "fas fa-check-circle"
  }), _vm._v(" Guaranteed origin products ")]), _c("div", [_c("i", {
    staticClass: "fas fa-coins"
  }), _vm._v(" Duty and delivery paid ")]), _c("div", [_c("i", {
    staticClass: "fas fa-shield-alt"
  }), _vm._v(" Secure payment ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/eye-on.svg"),
      alt: ""
    }
  }), _vm._v(" Activation ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/cart.svg"),
      alt: ""
    }
  }), _vm._v(" Cogs ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/cart-2.svg"),
      alt: ""
    }
  }), _vm._v(" Buy limit (bottles per year) ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/truck.svg"),
      alt: ""
    }
  }), _vm._v(" HS Code ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("i", {
    staticClass: "fas fa-comment-dollar"
  }), _vm._v(" Range price ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("i", {
    staticClass: "fas fa-funnel-dollar"
  }), _vm._v(" Range accessibility ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("i", {
    staticClass: "fas fa-exclamation-triangle"
  }), _vm._v(" Limited quantity ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("i", {
    staticClass: "fas fa-camera"
  }), _vm._v(" Tasting photo required ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/creditCard.svg"),
      alt: ""
    }
  }), _vm._v(" SKU ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v(" Bypass unicity verification on appellation. "), _c("br"), _vm._v(" Only verify the unicity of SKU ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("i", {
    staticClass: "fas fa-barcode"
  }), _vm._v(" TTB ID ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "title-big"
  }, [_c("i", {
    staticClass: "fas fa-barcode"
  }), _vm._v(" External references ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/glasses-type_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Type ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/glass_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Alcohol ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/wine_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Bottling ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/bottles_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Casings ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/leaf_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Average yield ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/wine-body_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Body structure ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/plant_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Soil ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/grapes_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Composition ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/cellar_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Aging potential ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/sun_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Vine orientation ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/temperature_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Temperature to keep ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/barrel_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Winemaking ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/account-vineyard_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Vineyard size ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "wine-details-bloc-title"
  }, [_c("img", {
    staticClass: "icon-wine",
    attrs: {
      src: require("@/assets/images/icons/wine-advice_grey.svg"),
      alt: ""
    }
  }), _vm._v(" Service advice ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-smaller"
  }, [_c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" All selected casings will be available to customers. ")]), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Even if not selected, OC1 will be available to ADMIN. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v(" Bypass unicity verification on appellation. "), _c("br"), _vm._v(" Only verify the unicity of SKU ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };